import { render, staticRenderFns } from "./EcommerceTransactions.vue?vue&type=template&id=bb3ecc00&scoped=true&"
import script from "./EcommerceTransactions.vue?vue&type=script&lang=js&"
export * from "./EcommerceTransactions.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTransactions.vue?vue&type=style&index=0&id=bb3ecc00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3ecc00",
  null
  
)

export default component.exports